module.exports = __webpack_public_path__ + "img/landing_box60.3d75d857.jpg";